import {useEffect, useState} from "react";
import {cloneDeep, isEmpty} from "lodash";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
  createUpdateCustomFields,
  requestFieldTypes,
  requestObjectTypes,
  requestRelatedObjectTypes,
} from "../../../redux/Actions/customFields.actions";
import {
  fieldTypes,
  objectTypes,
  relatedObjectTypes,
} from "../../../redux/Selectors/customFields.selector";
import {DEFAULT_FORM_DATA} from "./constants";

export const useFormData = (data = cloneDeep(DEFAULT_FORM_DATA), onCancel) => {
  const dispatch = useDispatch();
  const fieldTypesOptions = useSelector(fieldTypes);
  const objectTypesOptions = useSelector(objectTypes);
  const relatedObjectTypesOptions = useSelector(relatedObjectTypes);
  const [formData, setFormData] = useState({
    ...data,
  });
  const {choice_set, label, name, object_types, related_object_type, type} = formData;

  useEffect(() => {
    dispatch(requestFieldTypes());
    dispatch(requestObjectTypes());
    dispatch(requestRelatedObjectTypes());
  }, [dispatch]);

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prevData) => {
      const payload = {...prevData, [name]: value};
      if (name === "type") {
        payload.choice_set = null;
        payload.related_object_type = null;
        if (value === "boolean") {
          payload.default = false;
        } else {
          payload.default = null;
        }
      }
      return payload;
    });
  };

  const handleSubmit = () => {
    const isObjectType = type === "object" || type === "multiobject";
    const isSelectionType = type === "select" || type === "multiselect";
    if (
      isEmpty(name) ||
      isEmpty(label) ||
      isEmpty(object_types) ||
      isEmpty(type) ||
      (isObjectType && typeof related_object_type !== "number") ||
      (isSelectionType && typeof choice_set !== "number")
    ) {
      toast.error("Please check required fields");
      return;
    }

    dispatch(createUpdateCustomFields(formData, onCancel));
  };

  return {
    fieldTypesOptions,
    formData,
    handleChange,
    handleSubmit,
    objectTypesOptions,
    relatedObjectTypesOptions,
  };
};
